<script>export let faviconHtml;
</script>

<svelte:head>
  <!-- eslint-disable-next-line -->
  {@html faviconHtml}
</svelte:head>
